<div *ngFor="let consent of localConsents" style="flex-direction: column;">
  <div *ngIf="consent.tituloHTML" class="grey fs-7" [innerHTML]="consent.tituloHTML | safeHtml"></div>
  <div [ngClass]="{'accept': consent.aceptado === true, 'optional': !consent.obligatorio }" class="card">
    <section style="margin-top: 5px;">

        <div [innerHTML]="consent.descripcionCortaHTML | safeHtml"></div>

        <div 
            *ngIf="consent.descripcionHTML" 
            style="padding-top: 12px; padding-bottom: 12px; cursor: pointer;" 
            class="accent bold" 
            (click)="detailConsent(consent.descripcionHTML)"
        >Ver detalles</div>
        
        <mat-slide-toggle 
            color="primary" 
            [(ngModel)]="consent.aceptado" 
            (change)="verify()" 
            style="font-weight: bold;"
        >Acepto</mat-slide-toggle>

    </section>
</div>
</div>